
export const NavbarData =[
    {
        title : "Home",
        path:"/home",
    },
    {
        title : "Register workout",
        path:"/workout",
    },
    {
        title : "BMI CALCULATOR",
        path:"/workout/bmicalc",
    },
    {
        title : "Workout History",
        path:"/workoutlog",
    },
    {
        title : "Contact",
        path:"/Contact",
    },
]